export const DELETE_FILE_FAILURE = 'DELETE_FILE_FAILURE';

export const deleteFileFailure = error => ({
    type: DELETE_FILE_FAILURE,
    payload: error,
    error: true,
});
